import {SuggestionType} from './../types/personalizationCenter';
import Dexie from 'dexie';
import {getUsername} from '../../../_shared/GWTBridge/invoke/genPage';
import {PersonalizationCenter} from '../../../services/indexDB/indexeddbPersonalizationCenter';
import {SnoozedSuggestion, CenterData} from '../../Personalization/types/personalizationCenter';
import {getCompanyName} from '../../../utils/proto-api-utils/utils';

export const getIndexedData = async (db: PersonalizationCenter): Promise<CenterData> => {
    try {
        return db.centerData.get({userName: getUsername(), company: getCompanyName()});
    } catch (err) {
        console.log('Error trying to get Personalization Center data', err);
        return null;
    }
};

export const initDataCollection = async (db: PersonalizationCenter, data: SnoozedSuggestion) => {
    try {
        db.centerData.add({
            userName: getUsername(),
            company: getCompanyName(),
            data: [data]
        });
    } catch (err) {
        console.log('Error trying to initialize Personalization Center data', err);
    }
};

export const addSuggestion = async (db: PersonalizationCenter, suggestion: SnoozedSuggestion) => {
    return db.centerData
        .where('[userName+company]')
        .equals([getUsername(), getCompanyName()])
        .modify(ent => {
            ent.data.push(suggestion);
        })
        .catch(Dexie.ModifyError, error => {
            console.log('Error modifying personalization center entity', error);
        });
};

export const updateSuggeestion = async (
    db: PersonalizationCenter,
    index: number,
    snoozedSuggestion: SnoozedSuggestion
) => {
    return db.centerData
        .where('[userName+company]')
        .equals([getUsername(), getCompanyName()])
        .modify(ent => {
            if (snoozedSuggestion.type === SuggestionType.Searches) {
                ent.data[index] = {...snoozedSuggestion};
            } else {
                ent.data[index].reference = snoozedSuggestion.reference;
            }
        })
        .catch(Dexie.ModifyError, error => {
            console.log('Error updating reference of personalization center entity', error);
        });
};

export const resetSuggestion = async (db: PersonalizationCenter, index: number) => {
    return db.centerData
        .where('[userName+company]')
        .equals([getUsername(), getCompanyName()])
        .modify(ent => {
            ent.data.splice(index, 1);
        })
        .catch(Dexie.ModifyError, error => {
            console.log('Error reseting reference of personalization center entity', error);
        });
};
